<div class="cursor-pointer w-auto text-right flex items-center justify-end " (click)="closeClicked()">
  <vw-icon-svg iconUrl="/assets/svg/close2.svg" additionalClasses="cursor-pointer" width="26px"
    height="26px"></vw-icon-svg>
</div>
